export function getCalendarGridAgendaDays({ days, itemsByDay }) {
  return days.filter(day => itemsByDay[day.date]?.length > 0)
}

export function getHasCalendarGridAgendaDays(agendaDays) {
  return agendaDays.length > 0
}

export function getCalendarGridAgendaEmptyMessage({ emptyMessage, t }) {
  return emptyMessage ?? { text: t('Calendar.EmptyAgendaKey') }
}
